import { useNavigation, useRoute } from '@react-navigation/core';
import React, { useEffect, useReducer } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { airPoliciesList } from '../../constants/defaultData';
import { Modals } from '../../constants/ScreenNames';
import { widgetStyles } from '../../styles/theme';
import SelectorWidgetInput from '../EventWidget/SelectorWidgetInput';
import ExpenseFormItem from '../ExpenseWidget/ExpenseFormItem';
import WidgetTitle from './WidgetTitle';

const airInitialState = {
  primaryAirport: null,
  secondaryAirport: null,
  policyGroup: null,
};

const airReducer = (state, action) => {
  if (action.type) {
    return {
      ...state,
      [action.type]: action.value,
    };
  } else {
    return state;
  }
};

const AirSettingsWidget = (props) => {
  const navigation = useNavigation();
  const route = useRoute();
  const [state, dispatch] = useReducer(airReducer, airInitialState);
  const { selectedLocation, selectedElement } = route?.params || {};

  useEffect(() => {
    if (selectedLocation?.inputName === 'primaryAirport') {
      dispatch({ type: 'primaryAirport', value: selectedLocation });
    } else if (selectedLocation?.inputName === 'secondaryAirport') {
      dispatch({ type: 'secondaryAirport', value: selectedLocation });
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (selectedElement && selectedElement.id && selectedElement.inputName === 'airPolicyGroup') {
      dispatch({
        type: 'policyGroup',
        value: selectedElement.id,
      });
    }
  }, [selectedElement]);

  return (
    <View {...props}>
      <WidgetTitle label="Air Settings" iconName="plane" />
      <View style={widgetStyles.widget}>
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(Modals.StationAutoCompleteModal, {
              returnScreen: route.name,
              source: 'to',
              index: 0,
              hasHotel: false,
              hasAir: true,
              inputName: 'primaryAirport',
            })
          }
        >
          <ExpenseFormItem
            label="Primary Airport"
            value={state.primaryAirport ? state.primaryAirport.displaylabel : null}
            icon="mark"
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() =>
            navigation.navigate(Modals.StationAutoCompleteModal, {
              returnScreen: route.name,
              source: 'to',
              index: 0,
              hasHotel: false,
              hasAir: true,
              inputName: 'secondaryAirport',
            })
          }
        >
          <ExpenseFormItem
            label="Secondary Airport"
            value={state.secondaryAirport ? state.secondaryAirport.displaylabel : null}
            icon="mark"
            style={widgetStyles.topBorder}
          />
        </TouchableOpacity>
        <SelectorWidgetInput
          label="Policy Group"
          value={state.policyGroup ? airPoliciesList[state.policyGroup].label : null}
          onPress={() =>
            navigation.navigate(Modals.SelectorModal, {
              returnScreen: route?.name,
              options: airPoliciesList,
              selectedId: state.policyGroup,
              inputName: 'airPolicyGroup',
            })
          }
          style={widgetStyles.topBorder}
        />
      </View>
    </View>
  );
};

export default AirSettingsWidget;
